import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router';
import linkNavigator from '../linkNavigator';
import BackgroundImage from '../../../publisher/components/BackgroundImage';
import PlaceHolder from '../PlaceHolder';
const Image = ({ backgroundColor, backgroundImage, link, editData, limitToPageWidth, }) => {
    const navigate = useNavigate();
    const isEmpty = () => (!backgroundImage?.assetId);
    if (editData && isEmpty()) {
        return (_jsx(PlaceHolder, { placeHolderName: "Configure Image" }));
    }
    return (_jsx(Box, { sx: {
            position: 'relative',
            background: backgroundColor || 'inherit',
            textAlign: 'left',
            cursor: (link && link.type !== 'none') ? 'pointer' : 'inherit',
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, onClick: () => {
            // if in edit mode the link should not be active
            if (editData) {
                return;
            }
            linkNavigator(link, navigate);
        }, children: _jsx(BackgroundImage, { backgroundImage: backgroundImage }) }));
};
Image.meta = {
    group: 'design',
    name: 'Image',
    sort: 30,
    description: 'Component displays the Image',
    props: [
        {
            key: 'backgroundImage',
            name: 'Image',
            type: 'backgroundImage',
            description: 'Image to appear behind text.',
        },
        {
            key: 'link',
            name: 'Link',
            type: 'link',
            description: 'Optional link for when user clicks on image.',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit To Max Page Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'Image',
        props: {
            verticalAlignment: 'center',
            limitToPageWidth: true,
            link: {
                type: 'none',
            },
        },
    },
};
Image.getData = async ({ backgroundImage, context, }, store) => {
    await BackgroundImage?.getData({ backgroundImage, context }, store);
    return Promise.resolve('ok');
};
export default observer(Image);
//# sourceMappingURL=Image.js.map